<script lang="ts">
    export let condition: boolean;
    export let onClick: () => void;
</script>

<span role="button" tabindex="0" class="material-icons-outlined cursor-pointer transform transition-transform duration-500 ease-in-out {condition ? '-rotate-180' : ''}" on:click="{onClick}" on:keydown="{onClick}">
    expand_more
</span>
